<template>
  <div v-loading="loading" class="add-box">
    <div class="add-box-content">
        <template >
            <span class="label"><i style="color: red">*</i>添加方式</span>
            <el-radio-group :key="addType" v-model="addType">
                <el-radio-button 
                    v-for="item in addTypeList" 
                    :key="item.id" 
                    :label="item.value"
                >
                    {{ item.label }}
                </el-radio-button>
            </el-radio-group>
        </template>
        <keep-alive >
            <component 
                :is="compName"
                :dict="dict"
                :package="package"
                :type ="type"
                ref="comp"
            >
            </component>
        </keep-alive>
    </div>
    
    <div class="btns">
        <el-button @click="$emit('close')">取消</el-button>
        <el-button type="primary" :loading="saveLoading" @click="handleSubmit">添加</el-button>
    </div>
  </div>
</template>

<script>
// single batch
import Single from "./single.vue";
import Batch from "./batch.vue";
import { getAppEntryCnfigApi, getAppEntryGetMap } from '@/api'
const SINGLE_DATA = '1',BATCH_DATA = '2';
// import { config } from './mock'
export default {
    name: 'AddAppModal',
    props: [ 'cbs'],
    data() {
        return {
            saveLoading: false,
            addType: SINGLE_DATA,
            addTypeList: [//添加类型
                { value: SINGLE_DATA, label: '单个添加' },
                { value: BATCH_DATA, label: '批量添加' },
            ],
            appTypeList: [//产品类型
                { value: '2', label: '游戏' },
                { value: '1', label: '应用' },
            ],
            gameTypeList: [//游戏分类
                { value: '3', label: 'IAA' },
                { value: '4', label: 'IAP' },
            ],
            loading: false,
            dict: [],
            package:[],
            type: 'add' // add edit
        }
    },
    created() {
        this.getAppEntryList()
        this.getAppEntryCnfig()
    },
    computed: {
        compName() {
            switch (this.addType) {
                case SINGLE_DATA:
                    return Single
                case BATCH_DATA:
                    return Batch
                default:
                    return null;
            }
        },
        infoPids(){
            const { subproject_name = [], subproject_id= [], subproject_content= [] } = this.dict;
            return {
                namePids: subproject_name.map(v=>v.pid),
                contentPids: subproject_content.map(v=>v.pid),
                idPids: subproject_id.map(v=>v.pid),
            }
        },
        
    },
    methods: {
        async handleSubmit() {
            try {
                this.saveLoading = true
                const data = await this.$refs.comp.getFormData();
                const params = {
                    add_type: this.addType,
                    app_info: data
                };
                
                this.cbs.onSubmit(params, (b = false)=> {
                    this.saveLoading = b
                })
            } catch (error) {
                console.log(error);
               this.saveLoading = false
            }
        },
        async getAppEntryList() {
            try {
                const { data = [] } = await getAppEntryGetMap();
                this.package = data
            } catch (error) {
                this.$message.error(error.info)
            }
        },
        async getAppEntryCnfig() {
            try {
                this.loading = true
                const { data = [] } = await getAppEntryCnfigApi();
                this.dict = data
            } catch (error) {
                this.$message.error(error.info)
            }finally {
                this.loading = false
            }
        },
        async del(ids) {
            this.$refs.comp.filterList(ids)
        }
    }
}
</script>

<style lang="scss" scoped>
span.label {
    font-size: 12px;
    display: inline-block;
    width: 80px;
    text-align: right;
    padding-right: 12px;
    >i {
        padding-right: 6px;
    }
    padding-bottom: 24px;
}
.add-box {
    position: relative;
}
.add-box-content{
    max-height: 60vh;
    overflow-y: auto;
}
.btns {
    text-align: center;
    margin-top: 20px;
}
</style>